import { render, staticRenderFns } from "./scheduling-pendencies.vue?vue&type=template&id=404d0e4a"
import script from "./scheduling-pendencies.vue?vue&type=script&lang=js"
export * from "./scheduling-pendencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports